export default "__VITE_ASSET__DYxVirMI__"